import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SecurAuthService {

  private dataSubject = new BehaviorSubject<any>(null);
  public data$ = this.dataSubject.asObservable();
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) {}

  setData(data: any) {
    this.dataSubject.next(data);
  }

  get_auth_otp(data: any): Observable<any> {
    return this.http.patch(environment.base_url + "/app-auth-enable", data, this.httpOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleError(error);
      })
    );
  }

  app_auth_disable(data: any): Observable<any> {
    return this.http.patch(environment.base_url + "/app-auth-disable", data, this.httpOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleError(error);
      })
    );
  }

  web_admin_validate(data: any): Observable<any> {
    return this.http.patch(environment.base_url + "/web-admin-validate", data, this.httpOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleError(error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      console.error('An error occurred:', error.error);
    } else {
      // Server-side error
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error}`);
    }

    return throwError('Something bad happened; please try again later.');
  }
}
